import { getEndPoint } from './getEndPoint'
export const getCommentsByPostId = id =>
  getEndPoint('wp/v2/comments/?post=' + id)
